interface Props {
  className?: string;
  size?: number;
}

/**
 * Whale outline icon — uses /icons/whale.png via CSS mask so it inherits
 * `currentColor` from the parent (works with text-gray-500, text-red-400, etc.)
 * while keeping the clean monochrome outline shape from the source PNG.
 */
export default function WhaleIcon({ className = "", size = 14 }: Props) {
  return (
    <span
      role="img"
      aria-label="whale"
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        width: size,
        height: size,
        WebkitMaskImage: "url(/icons/whale.png)",
        maskImage: "url(/icons/whale.png)",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        transform: "scaleX(-1)",
      }}
    />
  );
}
